import { BasicSuccessPage } from "@component/assets/AbstractLeadForm/Steps/BasicSuccessPage";
import type { ReactNode } from "react";
import React from "react";
import { HomeSavingsSmallCalculator } from "./HomeSavingsSmallCalculator";
import * as Step from "./Steps";

/**
 * @Shortcode
 *
 * @title "Lakástakarék kalkulátor (partner)"
 * @shortcode "home_savings_small_partner"
 * @slug "lakastakarek_partner"
 * @type "calculator"
 */
export class HomeSavingsSmallCalculatorPartner extends HomeSavingsSmallCalculator {
	protected renderSteps(): ReactNode {
		const { submitState, homeSavingsResults, values, errorMessages } = this.state;

		return (
			<>
				<Step.Step1 stepName="step-1" defaultTarget="result" submitState={submitState} isPartner />
				<Step.Result
					stepName="result"
					defaultTarget="lead-form"
					results={homeSavingsResults}
					selectResult={this.selectResponse}
					submitState={submitState}
					canStepBack
				/>
				<Step.LeadForm
					stepName="lead-form"
					defaultTarget="success"
					title={this.renderLeadFormTitle()}
					submitState={submitState}
					canStepBack
				/>
				<BasicSuccessPage
					stepName="success"
					subscriptionTypes={["RETAIL_NEWSLETTER"]}
					userEmail={values.email}
				/>
				<Step.ErrorStep stepName="error-page" errors={errorMessages} canStepBack />
			</>
		);
	}

	protected getComponentName(): string {
		return "HomeSavingsSmallCalculatorPartner";
	}
}

export default HomeSavingsSmallCalculatorPartner;
